/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import ReportRecarga from './ReportRecarga';
import PropTypes from 'prop-types';

ReportarRecargaForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

function ReportarRecargaForm({ onClose, open }) {
  const handleClose = () => {
    onClose(false);
  };
  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>Reportar recarga</DialogTitle>
      <ReportRecarga handleClose={handleClose} />
    </Dialog>
  );
}

export default ReportarRecargaForm;
